<template>
  <section>
    <!--工具条-->
    <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addFormVisible = true">新增</el-button>
    </el-col>

    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="搜索" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>
    <el-table :data="tableData"
              border
              @selection-change="selsChange"
              v-loading="listLoading">
      <el-table-column
        label="用户名"
        prop="name"
        align="center">
      </el-table-column>
      <el-table-column
        label="店铺名称"
        prop="dianpu_name"
        align="center">
      </el-table-column>
      <el-table-column
        label="用户等级"
        align="center">
        <template scope="scope">
          {{adminLevel[scope.row.level]}}
        </template>
      </el-table-column>
      <el-table-column
        label="用户状态"
        align="center">
        <template scope="scope">
          {{userStatus[scope.row.status]}}
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="修改时间"
        prop="update_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        prop="labels"
        align="center">
        <template scope="scope">
          <el-button size="small" type="primary"  @click="authHandler(scope.row.id)">谷歌</el-button>
          <el-button size="small" type="primary"  @click="editHandler(scope.row)">修改</el-button>
          <el-button v-if="scope.row.status == 0"  size="small" type="primary"  @click="deleteHandler(scope.row)">删除</el-button>
           <el-button v-if="scope.row.status == 1"  size="small" type="primary"  @click="deleteHandler(scope.row)">恢复</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>
    <!--编辑界面-->
    <el-dialog title="二维码" v-model="qrcodeFormVisible" size="tiny"  >
      <div id="qrcode"  style="text-align: center;"></div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="qrcodeFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="qrcodeFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="200px" :rules="formRules" ref="addForm">
        <el-form-item label="用户名" prop="name">
          <el-col :span="16">
            <el-input v-model="addForm.name" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="密码" prop="pwd">
          <el-col :span="16">
            <el-input v-model="addForm.pwd" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="等级" prop="level">
          <el-select v-model="addForm.level"  placeholder="请选择">
            <el-option
              v-for="(item, index) in adminLevel"
              :key="index"
              :label="item"
              :value="index"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属店铺" prop="dianpu_id">
          <el-select v-model="addForm.dianpu_id" placeholder="请选择" style="width: 30%;">
            <el-option
              v-for="item in dianpuList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="200px" :rules="formRules" ref="editForm">
        <el-form-item label="用户名" prop="name">
          <el-col :span="16">
            <el-input v-model="editForm.name" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="密码" prop="pwd">
          <el-col :span="16">
            <el-input v-model="editForm.pwd" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="等级" prop="level">
          <el-select v-model="editForm.level"  placeholder="请选择">
            <el-option
              v-for="(item, index) in adminLevel"
              :key="index"
              :label="item"
              :value="index"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
           <el-form-item label="所属店铺" prop="dianpu_id" >
          <el-select v-model="editForm.dianpu_id" placeholder="请选择" style="width: 30%;">
            <el-option
              v-for="item in dianpuList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
   
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  var qr = require('qr-element');
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js'
  import basicdata from '../../static/config/basicdata.js'

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        qrcodeFormVisible:false,
        addForm: {
          name: '',
          pwd: '',
          create_time: '',
          update_time: '',
          auth: '',
          coins: 0,
          level: '',
          status: 0,
          dianpu_id:0
        },
        dianpuList:[],
        editFormVisible: false,
        editForm: {},
        formRules: {},
        visible2: false,
        adminLevel: basicdata.adminLevel,
        userStatus: basicdata.userStatus,
      }
    },
    methods: {
      authHandler(id){
        this.$confirm('谷歌验证码确定将重新生成(手机需要重新扫描)?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.qrcodeFormVisible=true;
          this.$axios.get(config.api_url + '/cpcadmin/qrcode/'+id
          ).then(response => {
            console.log(response)
            let data = response.data;
            var qrcode = qr(data, {
              width: 250,
              height: 250
            });
            document.getElementById('qrcode').innerHTML="";
            document.getElementById('qrcode').appendChild(qrcode);
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '请求异常，请联系管理员',
              type: 'warning'
            });
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/cpcadmin/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(this.addForm);
              para.level = parseInt(para.level);
              //异步请求
              this.$axios.post(config.api_url + '/cpcadmin',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      deleteHandler(row) {
        let text = '是否删除？';
        let status = 1;
        if(row.status == 1) {
          text = '是否恢复？'
          status = 0
        }
        this.$confirm(text, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.$axios.delete(config.api_url + '/cpcadmin/delete/' + row.id+ '/' + status
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(error => {
            this.$message({
              message: '操作异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },

      //勾选删除数据
      removeData() {
        if(this.selectRow.length > 0) {
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if(this.selectRow.length == 1) {
              this.$axios.delete(config.api_url + '/cpcadmin/delete/' + this.selectRow[0].id
              ).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '删除异常，请联系管理员',
                  type: 'error'
                });
              });
            } else {
              let ids = '',
                para = {};
              for(let row of this.selectRow) {
                ids += row.id + ','
              }
              ids = ids.substring(0,ids.length - 1);
              this.$axios.delete(config.api_url + '/cpcadmin/batch/delete/' + ids
              ).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '删除异常，请联系管理员',
                  type: 'error'
                });
              });
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else {
          this.$message({
            message: '请选择一条数据操作',
            type: 'warning'
          });
        }
      },
      //获取选中的数据
      selsChange(row) {
        this.selectRow = row
      },
      getDianpuList() {
        this.$axios.get(config.api_url + '/dianpu/list'
        ).then(response => {
          let data = response.data;
          if(data.state) {
            for(const item of data.msg) {
              this.dianpuList.push({
                label: item.dianpu_name,
                value: item.id
              });
            }
          } else {
            this.$message({
              message: '获取店铺失败',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取店铺异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //修改数据弹框
      editHandler(row) {
        this.editFormVisible = true;
        this.editForm = row;
        this.editForm.level = row.level.toString();
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(this.editForm);
              para.level = parseInt(para.level);
              //异步请求
              this.$axios.put(config.api_url + '/cpcadmin',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
    },
 
    created() {
      this.search();
      this.getDianpuList();
    }
  }
</script>

<style scoped>
  .rightsearch{
    float: right;
  }
</style>



// WEBPACK FOOTER //
// admin.vue?8da315bc